<template>
  <v-container grid-list-md text-md-center>
    <v-layout row wrap>
      <v-flex xl8 offset-xl2 xs12>

        <h1>{{ event.eventName }}</h1>

        <p class="info-text" v-html="eventInfo.introductionText">
        </p>

<!--        <div class="ma-12">-->
<!--          <v-btn-->
<!--            color="primary" x-large-->
<!--            rounded-->
<!--            tag="a"-->
<!--            href="https://cdn.nihongokyouinshiken.mext.go.jp/faq.pdf"-->
<!--            target="_blank"-->
<!--          >よくあるご質問-->
<!--          </v-btn>-->
<!--        </div>-->

        <div class="subTitle">
          <span>電子申請用メールアドレス登録</span>
        </div>
        <p class="info-text" v-html="eventInfo.emailRegistrationNotice">
        </p>

        <template v-if="entryOpened || isPre">
          <v-form ref="form">
            <v-text-field
              v-model="email"
              type="email"
              label="メールアドレス入力"
              outlined
              :rules="[rules.required, rules.email]"
            ></v-text-field>
            <v-flex>
            <v-btn
              color="primary"
              @click.stop="sendInvitation"
              class="pa-7"
            >下記のプライバシーポリシーに同意の上<br>
              電子申請用メールアドレスを登録する
            </v-btn>
            </v-flex>
              <v-flex>
            <v-btn text rounded class="my-2" tag="a" style="text-decoration: underline;" color="primary"
                   href="https://cdn.nihongokyouinshiken.mext.go.jp/privacypolicy.pdf" target="_blank">
              プライバシーポリシー
            </v-btn>
              </v-flex>
          </v-form>
        </template>
        <template v-else>
          <p></p>
        </template>

        <div class="subTitle">
          <span>お知らせ</span>
        </div>
        <p class="info-text" v-html="eventInfo.notificationsText">
          こちらには願書申請システムに関するお知らせと、試験前日～当日の緊急連絡に関する
          お知らせを掲載します。
        </p>

        <div class="subTitle">
          <span>出願申請の注意事項</span>
        </div>
        <p class="info-text" v-html="eventInfo.entryNotice">
          こちらには願書申請システムに関するお知らせと、試験前日～当日の緊急連絡に関する
          お知らせを掲載します。
        </p>

        <div class="ma-12">
          <v-btn
            color="primary" x-large
            rounded
            tag="a"
            href="https://cdn.nihongokyouinshiken.mext.go.jp/faq.pdf"
            target="_blank"
          >よくあるご質問
          </v-btn>
        </div>


        <div class="subTitle">
          <span>お問い合わせ先</span>
        </div>
        <p class="text-left pa-5">
          日本語教員試験センター<br />
          メールアドレス：nihongo-shikenjimukyoku@jsfit.co.jp
        </p>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import Rules from '../mixins/RulesMixin'
import {mapGetters} from 'vuex'


export default {
  mixins: [Rules],
  data () {
    return {
      email: '',
    }
  },
  computed: {
    ...mapGetters([
      'event', 'eventInfo', 'entryOpened', 'isPre', 'isAfterMypageClosedAt'
    ])
  },
  mounted () {
    if (process.env.VUE_APP_NODE_ENV == 'production') {
      // chatbotInit()
    }
  },
  methods: {
    async sendInvitation () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        let response = await axios.post('/api/account/register', {
          email: this.email
        })
        this.$emit('toast', 'メールを送信しました')
      } catch (e) {
        console.error('failed', e)
        if (e.response.status === 409) {
          return this.$emit('error', 'そのメールアドレスは既に登録されています')
        }
      }
    }
  }
}
</script>
